// LATAM VGI rápida uses the full legacy scale catalog from src/lib/scales-data.js
// rendered through InteractiveScaleCard. This list is intentionally independent
// from USA questionnaires and keeps LATAM as a flexible multi-scale workflow.

export const LATAM_FULL_SCALE_CATALOG = [
  { id: "barthel", label: "Índice de Barthel (0-100)" },
  { id: "mmse", label: "Mini-Mental MMSE (0-30)" },
  { id: "mna_sf", label: "MNA-SF Nutrición (0-14)" },
  { id: "yesavage", label: "Yesavage GDS-15 (0-15)" },
  { id: "phq9", label: "PHQ-9 (0-27)" },
  { id: "gad7", label: "GAD-7 (0-21)" },
  { id: "katz", label: "Índice de Katz ADL (0-6)" },
  { id: "lawton", label: "Lawton IADL (0-8)" },
  { id: "morse", label: "Escala de Morse (0-125)" },
  { id: "tinetti", label: "Tinetti Marcha/Equilibrio (0-28)" },
  { id: "frail", label: "Escala FRAIL (0-5)" },
  { id: "sarc_f", label: "SARC-F (0-10)" },
  { id: "cfs", label: "Clinical Frailty Scale (CFS) (1-9)" },
  { id: "charlson", label: "Índice de Charlson (0-37)" },
  { id: "eva_dolor", label: "EVA (Escala Visual Análoga) (0-10)" },
  { id: "sppb", label: "SPPB (Short Physical Performance Battery)" },
  { id: "moca", label: "MoCA (Montreal Cognitive Assessment) (0-30)" },
  { id: "mini_cog", label: "Mini-Cog" },
  { id: "cam", label: "CAM (Confusion Assessment Method)" },
  { id: "pfeiffer", label: "Pfeiffer SPMSQ (0-10 errores)" },
  { id: "norton", label: "Escala de Norton (5-20)" },
  { id: "gijon", label: "Escala de Gijón Sociofamiliar (5-25)" },
  { id: "zarit", label: "Zarit (Sobrecarga del cuidador) (0-48)" },
  { id: "tug", label: "TUG (Timed Up and Go) - segundos" },
  { id: "polifarmacia_simple", label: "Polifarmacia simple (recuento)" },
];

export const LATAM_WORKFLOW_SCALE_IDS = LATAM_FULL_SCALE_CATALOG.map((scale) => scale.id);
